import React, { FC } from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import { JUMPSTART_YOUR_FINANCIAL_JOURNEY } from "utils/strings";
import useWindowResizeListener from "hooks/useWindowResizeListener";

const Item = ({ label, icon, isMobile = false, link = "" }): FC => {
  return (
    <div
      className={`background-color-white flex-direction-column
   hoverable-component item`}
      onClick={() => {
        window.location.href = link;
      }}
      style={{ display: "flex", flex: 1 }}
    >
      <div
        className="center"
        style={{
          flex: 0.55,
          overflow: "hidden",
        }}
      >
        <img className="icon-image" src={icon} alt={label} />
      </div>
      <div
        style={{
          flex: 0.45,
          overflow: "hidden",
        }}
      >
        <p className="label bold">{label}</p>
      </div>
    </div>
  );
};

const QuickLinks = ({ quickLinks }): FC => {
  const { isMobile } = useWindowResizeListener();
  return (
    <div
      className={`quick-links-container center flex-direction-column background-color-${
        isMobile ? "light-gray" : `white`
      }`}
    >
      <Container
        className="center"
        style={{
          height: "fit-content",
          textAlign: "center",
          width: "90%",
        }}
      >
        <Typography className="section-title" color="primary" align="center">
          <strong> {JUMPSTART_YOUR_FINANCIAL_JOURNEY.toUpperCase()}</strong>
        </Typography>
        <br />

        <Grid
          container
          alignContent="center"
          color
          alignItems="center"
          spacing={1}
          className={`center`}
        >
          {quickLinks?.map(({ icon, label, ...rest }, idx) => (
            <Grid
              key={`${icon}-${label}-${idx}`}
              item
              md={4}
              lg={2}
              sm={6}
              xs={6}
              className="center"
            >
              <Item icon={icon} label={label} isMobile={isMobile} {...rest} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default QuickLinks;
